import { Button, Chip, Typography, useMediaQuery } from '@material-ui/core'
import {
  Add as AddIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons'
import clsx from 'clsx'
import { useCallback, useEffect, useState } from 'react'

export interface Props {
  keywords: string[]
  title?: string
  showKeywordButtonLabel?: string
  hideKeywordButtonLabel?: string
  breakPoint?: number
  heightThreshold?: number
  onSelect: (value: string) => void
}
export function PopularKeywords({
  keywords,
  title,
  showKeywordButtonLabel = 'もっと見る',
  hideKeywordButtonLabel = '閉じる',
  breakPoint = 480,
  heightThreshold = 40,
  onSelect,
}: Props) {
  const mobile = useMediaQuery(`(max-width:${breakPoint}px)`)
  const [open, setOpen] = useState(false)
  const [height, setHeight] = useState(0)
  const measuredRef = useCallback<(node: HTMLDivElement | null) => void>(node => {
    setHeight(node?.clientHeight || 0)
  }, [])
  useEffect(() => {
    setOpen(!mobile)
  }, [mobile])

  return (
    <div className="faq-filter-search-keyword">
      {title && (
        <Typography variant="h2" className="faq-filter-search-keyword__title">
          {title}
        </Typography>
      )}
      <div>
        <div
          ref={measuredRef}
          className={clsx('faq-filter-search-keyword__wrapper', {
            less: !open,
            more: open,
            noLoad: keywords.length === 0,
          })}
        >
          {keywords.map(k => (
            <Chip
              classes={{
                icon: 'faq-filter-search-keyword__plus',
                label: 'faq-filter-search-keyword__label',
              }}
              key={k}
              className={clsx('faq-filter-search-keyword-chip', 'faq-filter-search-keyword__chip')}
              icon={<AddIcon />}
              label={k}
              onClick={() => onSelect(k)}
            />
          ))}
        </div>
        <Button
          classes={{
            label: 'faq-filter-search-keyword-expand-button__label',
            endIcon: 'faq-filter-search-keyword-expand-button__icon',
          }}
          className={clsx(
            'faq-filter-search-keyword__button',
            'faq-filter-search-keyword-expand-button',
            {
              'faq-filter-search-keyword__button--mobile': mobile && height > heightThreshold,
            }
          )}
          endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          onClick={() => setOpen(prev => !prev)}
          size="small"
          fullWidth
        >
          {open ? hideKeywordButtonLabel : showKeywordButtonLabel}
        </Button>
      </div>
    </div>
  )
}
